export default "__VITE_ASSET__B3xDTijI__"